import React, { useEffect, useRef, useState } from 'react'
import Topbar from './Topbar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import OverView from './Overview'
import { useNavigate, useParams } from 'react-router-dom'
import { selectCourseModule, selectCourseModuleContent } from '../../redux/personaliseLessons/courseModuleSlice'
import { useSelector } from 'react-redux'
import { selectCourseList } from '../../redux/personaliseLessons/courseListSlice'
import { selectModuleProgress } from '../../redux/personaliseLessons/moduleProgressSlice'
import LearnTubeXIllustartion from './components/LearnTubeXIllustartion'
import { toast } from 'react-toastify'
import { selectAuthentication } from '../../redux/personaliseLessons/authenticationSlice'
import { selectBottomIllustationStatus } from '../../redux/personaliseLessons/bottomIllustration'
import { selectSubscriptionStatus } from '../../redux/personaliseLessons/subscriptionStatusSlice'

const LockedLessons = () => {

    const { module_slug, lesson_slug } = useParams()
    
    const [showOverview, setShowOverview] = useState(false)
    const [isAtEnd, setIsAtEnd] = useState(false)
    const [ lessonDetails, setLessonDetails ] = useState({})
    const [ lessonIndex, setLessonIndex ] = useState(0)
    const [ moduleDetails, setModuleDetails ] = useState({})
    
    const courseModuleContent = useSelector(selectCourseModuleContent)
    const subject_name = useSelector(selectCourseList)?.courseName
    const moduleProgress = useSelector(selectModuleProgress)
    const courseModule = useSelector(selectCourseModule)
    const authentication = useSelector(selectAuthentication)
    const bottomIllustrationStatus = useSelector(selectBottomIllustationStatus)
    const subscriptionStatus = useSelector(selectSubscriptionStatus)

    const sentinelRef = useRef(null)
    const navigate = useNavigate()


    useEffect(() => {
        const index  = courseModuleContent?.findIndex((item) => item?.module_slug === module_slug) - 1;
        console.log(courseModuleContent?.[index]?.module_progress);
        if (index >= 0 && courseModuleContent?.[index]?.module_progress === 100){
            toast.warning('Loading your Module. Please wait!')
        } else {
            toast.warning('Complete previous module to unlock this module.')
        }
    }, [])

    useEffect(() => {
        setModuleDetails(courseModuleContent?.filter((item) => item?.module_slug === module_slug)?.[0])

    }, [courseModuleContent, module_slug])

    useEffect(() => {
        setLessonDetails(moduleDetails?.module_content?.filter((item) => item?.lesson_slug === lesson_slug)?.[0])
    }, [lesson_slug, moduleDetails])
    
    useEffect(() => {
        setLessonIndex(moduleDetails?.module_content?.findIndex((item) => item?.lesson_slug === lesson_slug) + 1)
    }, [moduleDetails, lesson_slug])
    
    useEffect(() => {
        const sentinel = sentinelRef.current;
        const observer = new IntersectionObserver((entries) => {
            // If the sentinel comes into view, setIsAtEnd to true
            if (entries[0].isIntersecting) {
                setIsAtEnd(true);
            } else {
                setIsAtEnd(false);
            }
        });

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => {
            if (sentinel) {
                observer.unobserve(sentinel);
            }
        }
    }, [sentinelRef]);

    const handleCourseCrumb = () => {
        navigate(`/personalise/${encodeURIComponent(subject_name)}`)
    }
    
    return (
        <>
            {!showOverview ? <div className='text-white flex-1 mx-auto max-w-3xl'>
                <Topbar
                    name={"Lessons"}
                    showOverview={showOverview}
                    setShowOverview={setShowOverview}
                    lessonsCompleted={moduleProgress?.completed_lesson_count}
                    lessonLength={moduleDetails?.module_content?.length}
                />
                <div className='p-4'>
                    <div className=''>
                        <div className='mt-1 flex items-center'>
                            <p className='leading-[12px]'><span className='text-xs opacity-50 mr-1.5 cursor-pointer' onClick={handleCourseCrumb}>{ subject_name}</span>
                            <FontAwesomeIcon icon={faChevronRight} className='opacity-50 text-xs'/>
                            <span className='text-xs opacity-50 ml-1.5 cursor-pointer' onClick={() => {
                                setShowOverview(!showOverview)
                            }}>{lessonDetails?.lesson_name}</span>
                            </p>
                        </div>
                        <p className='text-xl mt-3 opacity-50'>Lesson {lessonIndex}</p>
                        <h3 className='text-xl font-bold leading-6 mt-2' >{lessonDetails?.lesson_name}</h3>
                    </div>
                    <div className='my-3 blur-[12px] mt-6'>
                        <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Learntube-5/Rectangle_5243.png?updatedAt=1689166516241" alt="" />
                    </div>
                </div>
                <div className='m-4'>
                    <div className='p-4 bg-[#2D4F71] rounded-xl relative'>
                        <h2 className='text-xl font-semibold'>Key Takeaways</h2>
                        <div className='blur-[3px]'>
                            <p className='leading-[19px] mt-3'>This video provides a comprehensive guide on defining your brand's target audience, a crucial step in identifying suitable influencers.</p>
                            <p className='leading-[19px] mt-3'>The insights gained will aid in finding and vetting influencers that align with your brand and resonate with your audience.</p>
                            <p className='leading-[19px] mt-3'>The knowledge will also assist in choosing between micro and macro influencers, ensuring the best fit for your brand.</p>
                        </div>
                    </div>
                </div>
                <div className='p-4'>
                    <h2 className='text-xl font-semibold mb-4'>Ask the Creator</h2>
                    <div className='bg-[#2D4F71] flex justify-between items-center rounded-xl h-16 p-2 blur-sm'>
                        <div className='bg-[#17395A] w-full h-[44px] relative'>
                            <p className='absolute top-2 right-2 text-[#3791EC]'>Send</p>
                        </div>
                    </div>
                </div>
                <div className='mx-4 mt-7 rounded-lg'>
                    <h2 className='text-xl font-semibold mb-1'>Quiz</h2>
                    <p className='italic text-sm opacity-50 mb-4'>Complete quiz to mark this lesson as complete</p>
                    <div className='bg-[#2D4F71] p-4 blur-[3px] rounded-xl'>
                        <p className='leading-[19px]'>What are the two types of data (demographics and ____) that you need to understand about your target market, and how do they differ?</p>
                        <div className='w-full h-[120px] bg-[#1D3854] rounded-xl p-3 mt-4'>
                            <p className='opacity-50'>Answer this question in 2-3 lines</p>
                        </div>
                        <div className='bg-[#7FC241] w-[40%] text-center py-2 rounded-xl mt-3'>Submit</div>
                    </div>
                </div>
                {subscriptionStatus?.type === 'course_purchased' || bottomIllustrationStatus?.show_banner ? <div className='p-4 mt-4'>
                    <LearnTubeXIllustartion
                        sentinelRef={sentinelRef}
                        isAtEnd={isAtEnd}
                        setIsAtEnd={setIsAtEnd}
                        course_slug={subject_name}
                        authentication={authentication}
                    />
                </div> : <div className='w-full h-8'></div>}
            </div> : 
            <OverView
                showOverview={showOverview}
                setShowOverview={setShowOverview}
                courseName={subject_name}
                courseModule={courseModule}
                lessonId={lessonDetails?.lesson_id}
            />}
        </>
    )
}

export default LockedLessons
